module.exports = __webpack_public_path__ + "static/media/user-remove.2f30d1e9.svg";